<script setup lang="ts">
import { computed } from 'vue';
import InactiveBenchmarkGauge from './InactiveBenchmarkGauge.vue';
import InactiveBenchmarkDrivers from './InactiveBenchmarkDrivers.vue';
import { InactiveProgramData } from '@Shared/types/portal/BenchmarkInterfaces';

interface InactiveProgram {
  data: InactiveProgramData;
  index: number;
  standardizedProgramName: string;
  maxDriverCount: number;
}

const inactiveProgram = defineProps<InactiveProgram>();
const programData = computed(() => inactiveProgram.data);
</script>

<template>
  <div class="flex flex-col gap-8 items-center w-full">
    <!-- Gauge Component -->
    <div class="flex justify-center w-full">
      <div class="w-full max-w-2xl">
        <InactiveBenchmarkGauge
          :standardized-program-name="standardizedProgramName"
          :title="programData.programFriendlyName"
          :index="index"
        />
      </div>
    </div>

    <!-- Drivers Component -->
    <div class="flex justify-center w-full">
      <div class="w-full max-w-2xl">
        <InactiveBenchmarkDrivers :max-driver-count="maxDriverCount" />
      </div>
    </div>
  </div>
</template>
